/* eslint-disable @typescript-eslint/no-explicit-any */
export const getErrors = (errorResponse: any) => {
  if (typeof errorResponse === 'object') {
    if (errorResponse?.error_msg) return errorResponse.error_msg;
    if (errorResponse?.error_message) return errorResponse.error_message;
    if (errorResponse?.message) return errorResponse.message;
    if (typeof errorResponse === 'string') {
      return errorResponse;
    }

    const res = flatten(errorResponse);
    if (Object.keys(res).length) {
      const msgKey = Object.keys(res).find(
        (item) => item.indexOf('message') > 0 || item.indexOf('msg') > 0 || item.indexOf('message') > 0
      );

      if (msgKey) {
        return res[msgKey as keyof typeof res];
      }

      const [k] = Object.keys(res);
      return res[k as keyof typeof res];
    }
  }
  return undefined;
};

function traverseAndFlatten(currentNode: any, target: any, flattenedKey?: any) {
  Object.keys(currentNode).forEach((key) => {
    // eslint-disable-next-line no-prototype-builtins
    if (currentNode.hasOwnProperty(key)) {
      let newKey;
      if (flattenedKey === undefined) {
        newKey = key;
      } else {
        newKey = `${flattenedKey}.${key}`;
      }

      const value = currentNode[key];
      if (typeof value === 'object') {
        traverseAndFlatten(value, target, newKey);
      } else {
        target[newKey] = value;
      }
    }
  });
}

function flatten(obj: any) {
  const flattenedObject = {};
  traverseAndFlatten(obj, flattenedObject);
  return flattenedObject;
}
